import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import PickleballHero from '../components/pickleball/PickleballHero';
import PickleballFramework from '../components/pickleball/PickleballFramework';
import PickleballExperience from '../components/pickleball/PickleballExperience';
import PickleballPrograms from '../components/pickleball/PickleballPrograms';
import PickleballTestimonials from '../components/pickleball/PickleballTestimonials';
import PickleballCoaches from '../components/pickleball/PickleballCoaches';
import PickleballCTA from '../components/pickleball/PickleballCTA';

const Pickleball = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": "The Paradox of Pickleball",
    "description": "A movement-based coaching experience where patterns in your pickleball game reveal how you navigate pressure, partnership, and power in all areas of life.",
    "url": "https://www.paradoxedge.com/pickleball",
    "provider": {
      "@type": "Organization",
      "name": "ParadoxEdge",
      "url": "https://www.paradoxedge.com"
    }
  };

  return (
    <>
      <SEOHead
        noindex
        title="The Paradox of Pickleball - Thriving Through Play"
        description="Play the game. Master yourself. A movement-based coaching experience where pickleball reveals how you navigate pressure, partnership, and power in life."
        canonicalUrl="/pickleball"
        keywords="pickleball coaching, leadership development, executive retreat, doubles strategy, mental performance, movement-based coaching"
        jsonLd={jsonLd}
      />
      <div className="min-h-screen bg-background">
        <Navigation />
        <main>
          <PickleballHero />
          <PickleballFramework />
          <PickleballExperience />
          <PickleballPrograms />
          <PickleballTestimonials />
          <PickleballCoaches />
          <PickleballCTA />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Pickleball;
